import { useState } from "react";

import { useGlobal } from "../../../contexts/globalContext";
import { Audio } from "../../audio-element";

import { Controls } from "./controls";
import { UserCamera } from "./user-camera";

export const UsersCameraAndControls = () => {
  const { MEETING_STATE } = useGlobal();
  const [talking, setTalking] = useState(false);

  return (
    <div className="meeting-controller-widget" onMouseOver={() => setTalking(true)} onMouseOut={() => setTalking(false)}>
      <Controls />
      <UserCamera talking={talking} />
      <Audio className="hide" playsInline controls srcObject={MEETING_STATE.meetingAudioStream} />
    </div>
  );
};
